// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x4bo","name":"styles_name__2djrT","phone":"styles_phone__2EkrY"};